var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.up_s0 { fill: #533ffb } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-workspace-task-upload-documents"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon-workspace-task-create-folder-path",
    fillRule: "evenodd",
    className: "up_s0",
    d: "m20 8v13.8c0 1.2-1 2.3-2.3 2.3h-13.8c-1.3 0-2.3-1.1-2.3-2.3v-18.4c0-1.3 1-2.3 2.3-2.3h9.2zm-4.6 4.6h-3.5v-3.5h-2.3v3.5h-3.4v2.3h3.4v3.4h2.3v-3.4h3.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDocuments);
export default __webpack_public_path__ + "static/media/upload-documents.1aa769b985ab0f9c807537d26146f306.svg";
export { ForwardRef as ReactComponent };